<template>
  <div class="user-history-box">
    <user-header></user-header>
    <user-menu :status='2'></user-menu>
    <div class="user-contents-main-box">
      <div class="history-main-box">
        <div class="hitstory-box" v-for="(history, index) in historys" :key="index">
          <div class="history-header clearfix">
            <p class="order-right">注文番号：{{history.id}}</p>
            <p class="order-date">注文日：{{date_string(history.order_date)}}</p>

            <p class="order-total">合計：<label class="total">￥{{total_price(history)}} </label>{{sub_total_price(history)}}</p>
            <p class="order-send">お届け先：
              [{{history.name}}]
              〒{{history.zip_code}}
              {{history.prefecture}}
              {{history.address1}}
              {{history.address2}}
            </p>
            <div class="order-status"><span class="status">ステータス</span><span :class="`status-c-${history.status}`">{{status_string(history.status)}}</span></div>

          </div>
          <div class="history-constent clearfix" v-for="(order, index3) in history.orders" :key="index3">
            <div class="history-content-right">
              <p>￥{{yen(order.price)}} <span class="tax-out">(税抜)</span></p>
              <button type="button" class="re-buy" @click="re_buy(order)">もう一度購入する</button>
            </div>


            <div class="flex">
              <div class="item-box">
                <p class="item-box-title">茶葉</p>
                <p class="" v-for="(item, index2) in order.item" :key="index2">・{{items_id_list[item].name}}</p>
              </div>
              <div class="item-box2">
                <p class="item-box-title">焙煎</p>
                <p>{{roasted_text(order.roasted)}}</p>
              </div>
              <div class="item-box3">
                <p class="item-box-title">内容量 / 個数</p>
                <p>{{order.weight}}g × {{order.num}}個</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="historys.length == 0" class="no-buy">購入履歴がありません。</div>
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'UserHistory',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      items_id_list: this.$store.getters['uItemList/items_id_list'],
      roasteds: [{'type': '浅煎り(Light)', 'value': 1}, {'type': '中煎り(Medium)', 'value': 2}, {'type': '深煎り(Dark)', 'value': 3}],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    historys () { return this.$store.getters['uHistory/historys']; },
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    let ld = new this.$loader(this);
    ld._data_set({});
    ld._post_cb_f = this.history_get_cb;
    ld._load_start('/user/history_get.php');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    history_get_cb (data) {
      if (data.res === 1) {
        this.$store.commit('uHistory/set_data', data.data);

      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    total_price (item) {
      let price = item.total_price + item.tax + item.post_price;
      price = this.$lib._yen(price);
      return price;
    },
    sub_total_price (item) {
      return `(税:￥${this.$lib._yen(item.tax)} / 送料:￥${this.$lib._yen(item.post_price)})`;
    },
    roasted_text (n) {
      const obj = this.roasteds.filter(function (item){
        if (item.value === n) return true;
      });
      return obj[0].type;
    },
    yen (p) {
      return this.$lib._yen(p);
    },
    date_string (date) {
      return `${date.substr(0, 4)}年${this.$lib._zero_del(date.substr(4, 2))}月${this.$lib._zero_del(date.substr(6, 2))}日`;
    },
    re_buy (history) {
      // const cart = {'item': history.item, 'roasted': history.roasted, 'weight': history.weight, 'num': history.num, 'price': 0};
      const cart = history;
      this.price(cart);
      this.$store.commit('uCart/set_item', cart);
      this.$router.push({name: 'uMain', params: {}});
    },
    price (item) {
      let p = 0;
      const num = item.item.length;
      if (num === 0) {
        return p;
      }
      const w = item.weight / num;

      for (let i = 0; i < num; i++) {
        p += this.items_id_list[item.item[i]].unit_price * w;
      }

      p = p * item.num;
      item.price = p;
    },
    status_string (flg) {
      let status = '';
      switch (flg) {
        case 1:
          status = '注文';
          break;
        case 2:
          status = '受付済み';
          break;
        case 3:
          status = '製造中';
          break;
        case 4:
          status = '発送済み';
          break;
      }
      return status;
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-history-box {
  .user-contents-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
    .history-main-box {
      margin: 0 auto;
    }
    .hitstory-box {
      border: 5px solid #dddddd;
      max-width: 1000px;
      margin: 0 auto 20px auto;
    }
    .history-header {
      background: #f3f4f1;
      border-bottom: 1px solid #dddddd;
      padding: 10px 10px 5px 10px;
      p {
        text-align: left;
        line-height: 1.8;
        color: #1e3032;
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 16px;
      }
      p::before {
        content: '';
        border-left: 6px solid #df274c;
        padding: 5px;
      }
    }
    .order-right {
      width: 180px;
      float: right;
    }
    .order-date {
      width: 220px;
    }
    p.order-total {
      line-height: 1.6;
    }
    .order-send {
      float: left;
    }
    .order-status {
      margin-top: -32px;
      border: 1px solid #dddddd;
      background: #fdffc0;
      width: 180px;
      height: 58px;
      float: right;
      font-weight: 600;
    }
    .status {
      color: #e65766;
      font-size: 14px;
      display: block;
      padding: 5px 0 0 0;
    }
    .status-c-1 {
      color: #1880a0;
    }
    .status-c-2 {
      color: #bd1e16;
    }
    .status-c-3 {
      color: #0ea355;
    }
    .status-c-4 {
      color: #bd8500;
    }
    .history-constent {
      padding: 10px;
      text-align: left;
      background: #fefefe;
      color: #5c5945;
      border-bottom: 1px dashed #dddddd;
    }
    .history-constent:last-child {
      border-bottom: 0px;
    }
    .history-content-right {
      float: right;
      p {
        text-align: right;
        color: #a91b18;
        font-weight: 600;

      }
    }
    .clearfix:after {
      clear: both;
      content: '';
      display: block;
    }
    .re-buy {
      width: 150px;
      height: 32px;
      color: #fefefe;
      border: initial;
      border-radius: 5px;
      font-size: 16px;
      margin-top: 10px;
      cursor: pointer;
    }
    .total {
      font-size: 18px;
      color: #a91b18;
      font-weight: 600;
    }
    .flex {
      display: flex;
      flex-wrap: wrap;
    }
    .item-box {
      width: 180px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .item-box2 {
      width: 180px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .item-box3 {
      width: 180px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .item-box-title {
      font-size: 14px;
      font-weight: 600;
      background-color: #d4ff9d;
      padding: 3px;
    }
    .no-buy {
      margin-top: 100px;
      color: #a91b18;
    }
    .tax-out {
      color: #1e3032;
      font-size: 12px;
    }
  }
  @media (max-width: 767px) {
    .user-contents-main-box {
      padding: 20px;
      margin: 50px 0 0 0;
      height: calc(100vh - 90px);
      .order-right {
        float: none;
      }
      .order-send {
        float: none;
      }
      .order-status {
        float: none;
        margin-top: 0px;
      }
    }
  }
}
</style>
